module.exports = __webpack_public_path__ + "static/paperPlane-dc14b9ee105c52a69ff8d927347a6902.png";